var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1736)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3874 24.8544H42.8783C41.6547 24.8544 40.6831 23.8948 40.6831 22.6713V11.6595C40.6831 11.2397 41.031 10.9038 41.4508 10.9038C41.8706 10.9038 42.2065 11.2397 42.2065 11.6595V22.6713C42.2065 23.0431 42.5424 23.379 42.9262 23.379H50.4354C50.8072 23.379 51.1431 23.0431 51.1431 22.6713V11.6595C51.1431 11.2397 51.479 10.9038 51.9108 10.9038C52.3306 10.9038 52.6665 11.2397 52.6665 11.6595V22.6713C52.5825 23.8948 51.6109 24.8544 50.3874 24.8544Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6327 24.8546C46.2128 24.8546 45.877 24.5187 45.877 24.0989V11.6117C45.877 11.1918 46.2128 10.856 46.6327 10.856C47.0525 10.856 47.3884 11.1918 47.3884 11.6117V24.1468C47.3524 24.5667 47.0165 24.8546 46.6327 24.8546Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6327 33.1676C46.2128 33.1676 45.877 32.8318 45.877 32.4119V24.1471C45.877 23.7153 46.2128 23.3794 46.6327 23.3794C47.0525 23.3794 47.3884 23.7153 47.3884 24.1471V32.4479C47.3524 32.8318 47.0165 33.1676 46.6327 33.1676Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.156 49.0612H45.1572C44.6054 49.0612 44.1855 48.6894 44.1855 48.1376V32.6155C44.1855 32.1117 44.6054 31.6919 45.1572 31.6919H48.156C48.6598 31.6919 49.1276 32.1117 49.1276 32.6155V48.1856C49.0797 48.6894 48.6598 49.0612 48.156 49.0612Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.831 34.1751C17.8681 34.1751 15.2171 32.5318 13.8617 29.8328C13.6937 29.4609 13.8257 29.0291 14.2095 28.8612C14.5814 28.6932 15.0012 28.8252 15.1692 29.209C16.2727 31.3562 18.4199 32.6997 20.783 32.6997C23.1461 32.6997 25.3772 31.3082 26.3968 29.209C26.5648 28.8252 27.0206 28.6932 27.3565 28.8612C27.7403 29.0291 27.8723 29.4969 27.7043 29.8328C26.5168 32.4958 23.7818 34.1751 20.831 34.1751Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8308 16.3018C14.2453 16.3018 7.58789 14.6585 7.58789 11.5277C7.58789 9.81233 9.67509 8.40887 13.2857 7.55719C13.0698 8.48084 12.8899 9.41648 12.7579 10.3161C12.602 11.3357 13.2257 12.3194 14.1973 12.6672C16.3565 13.4229 18.5397 13.8428 20.8308 13.8428C23.0619 13.8428 25.2331 13.303 27.3803 12.6912C28.3879 12.3913 29.0476 11.3597 28.8917 10.3161C28.7597 9.40448 28.5918 8.45685 28.3759 7.5332C32.0105 8.36088 34.1097 9.81233 34.1097 11.5277C34.1097 14.6585 27.4522 16.3018 20.8308 16.3018Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8308 12.4155C18.8395 12.4155 16.8603 12.0436 14.6651 11.3239C14.3293 11.1919 14.1253 10.8561 14.1613 10.5202C14.4132 8.99677 15.7207 1.3677 18.6356 0.564012C19.1754 0.396077 19.9431 0.444058 20.8308 1.19977C21.7064 0.444058 22.4741 0.444058 23.0139 0.564012C25.9288 1.3677 27.2363 8.99677 27.4882 10.5202C27.5362 10.8561 27.3203 11.2399 26.9844 11.3239C24.7892 12.0436 22.81 12.4155 20.8308 12.4155Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6778 26.126H19.0552C15.8044 26.126 13.1895 23.511 13.1895 20.2603V16.9496C16.0444 17.5733 19.0792 17.7173 20.8305 17.7173C22.6058 17.7173 25.7246 17.5733 28.6275 16.9136V20.2603C28.5435 23.511 25.8806 26.126 22.6778 26.126Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5453 30.3005C14.3294 30.3005 14.0775 30.1686 13.9455 30.0006C13.6936 29.6648 13.7776 29.2089 14.1255 28.993C15.6849 27.8535 16.9084 24.9866 16.9084 24.9386C17.0763 24.5667 17.4962 24.3988 17.868 24.5188C18.2519 24.6867 18.4198 25.1185 18.2999 25.4904C18.2519 25.6223 16.9084 28.7771 15.0011 30.1686C14.8812 30.2525 14.7132 30.3005 14.5453 30.3005Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1043 30.3005C26.9363 30.3005 26.8164 30.2525 26.6844 30.1685C24.8371 28.7771 23.4817 25.6223 23.4457 25.4903C23.2657 25.1185 23.4817 24.6866 23.8655 24.5187C24.2374 24.3508 24.6572 24.5667 24.8371 24.9385C24.8371 24.9865 26.0607 27.8534 27.5721 28.993C27.908 29.2449 27.9559 29.7127 27.74 30.0006C27.5721 30.1685 27.3562 30.3005 27.1043 30.3005Z",
    fill: "#A2BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2633 51.4725H33.6418V39.4891C33.6418 39.0692 33.306 38.7334 32.8861 38.7334H31.5786V30.3246C37.1925 33.2035 40.947 39.1892 40.947 45.9426V50.7527C41.031 51.1366 40.6831 51.4725 40.2633 51.4725ZM30.0552 38.7334H11.6303V29.6049C12.5059 29.269 13.4296 29.0051 14.3772 28.8252C14.7971 28.7412 15.1689 28.9931 15.2169 29.4129C15.2169 29.4369 15.2289 29.4489 15.2289 29.4729H26.3366C26.3366 29.4489 26.3486 29.4369 26.3486 29.4129C26.4326 29.0291 26.8164 28.7412 27.1883 28.8252C28.1839 29.0171 29.1436 29.293 30.0552 29.6529V38.7334ZM10.1189 38.7334H8.76339C8.34355 38.7334 8.00768 39.0692 8.00768 39.4891V51.4725H1.42221C1.00237 51.4725 0.666504 51.1366 0.666504 50.7167V45.9426C0.666504 39.1172 4.45705 33.1075 10.1189 30.2766V38.7334ZM32.1664 51.4725H9.5191V40.2568H10.8746H30.8229H32.1664V51.4725Z",
    fill: "#A2BD3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducers);
export default __webpack_public_path__ + "static/media/producers.d92aa06f1028d2504fef915a22f092a7.svg";
export { ForwardRef as ReactComponent };